import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Spin, Typography, Card, Row, Col, Tag } from 'antd';
import api from '../../api';
import { DEFAULT_GUTTER } from '../../constants';
import dayjs from 'dayjs';
import Footer from '../../Components/Footer';
import SEOHead from '../../Components/SEOHead';
import CallToAction from '../../Components/CallToAction';
import { useTranslations } from "../../lang";

const { Title, Text } = Typography;

export default function BlogTag() {
    const { tag } = useParams();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { language, translate: t } = useTranslations();

    useEffect(() => {
        if (tag) {
            setLoading(true);
            api.getBlogsByTag(tag, language).then((blogItems) => {
                setBlogs(blogItems);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [tag, language]);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '3rem' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <>
            <SEOHead
                title={`${t('Blog artikelen met tag')}: ${tag} - Oogst.app`}
                description={`${t('Bekijk alle blog artikelen met de tag')} ${tag}`}
                keywords={`${tag}, blog, moestuin, oogst`}
            />
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem' }}>
                <Title level={1} style={{ marginBottom: '1rem' }}>
                    {t('Artikelen met tag')}: <Tag color="green" style={{ fontSize: '1.5rem', padding: '0.5rem 1rem' }}>{tag}</Tag>
                </Title>
                <Text type="secondary" style={{ display: 'block', marginBottom: '2rem', fontSize: '1.1rem' }}>
                    {blogs.length} {t('artikelen gevonden')}
                </Text>

                <Row gutter={DEFAULT_GUTTER}>
                    {blogs.length === 0 ? (
                        <Col span={24}>
                            <Card>
                                <Text>{t('Geen artikelen gevonden met deze tag')}.</Text>
                            </Card>
                        </Col>
                    ) : (
                        blogs.map((blog) => (
                            <Col xs={24} md={12} lg={8} key={blog.id}>
                                <Link to={`/blog/${blog.slug}`} style={{ textDecoration: 'none' }}>
                                    <Card
                                        hoverable
                                        cover={
                                            blog.thumbnail && (
                                                <img
                                                    alt={blog.title}
                                                    src={blog.thumbnail}
                                                    style={{
                                                        height: '200px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            )
                                        }
                                        style={{ height: '100%' }}
                                    >
                                        <Title level={4} style={{ marginBottom: '0.5rem', color: '#006e2f' }}>
                                            {blog.title}
                                        </Title>
                                        {blog.meta_description && (
                                            <Text type="secondary" style={{
                                                marginBottom: '1rem',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical'
                                            }}>
                                                {blog.meta_description}
                                            </Text>
                                        )}
                                    </Card>
                                </Link>
                            </Col>
                        ))
                    )}
                </Row>
            </div>
            <CallToAction />
            <Footer />
        </>
    );
}
